const WalletIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="1em"
         height="1em"
         fill="currentColor">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 4.59615V14.4039C2 15.8377 3.19391 17 4.66667 17H14.7408C16.2135 17 17.4075 15.8377 17.4075 14.4039V13.2501C17.7673 12.987 18 12.568 18 12.0962V9.78842C18 9.31658 17.7673 8.89764 17.4075 8.6345V7.76923C17.4075 6.33541 16.2135 5.17308 14.7408 5.17308H13.8518V4.59615C13.8518 3.16234 12.658 2 11.1852 2H4.66667C3.19391 2 2 3.16234 2 4.59615ZM4.66667 3.73077C4.17575 3.73077 3.77779 4.11821 3.77779 4.59615V5.17308H12.0741V4.59615C12.0741 4.11821 11.6761 3.73077 11.1852 3.73077H4.66667ZM16.2223 10.0769H11.7778V11.8077H16.2223V10.0769ZM15.6296 8.34614V7.76923C15.6296 7.29128 15.2317 6.90384 14.7408 6.90384H3.77779V14.4039C3.77779 14.8817 4.17576 15.2692 4.66667 15.2692H14.7408C15.2317 15.2692 15.6296 14.8817 15.6296 14.4039V13.5384H11.4815C10.6633 13.5384 9.99998 12.8927 9.99998 12.0962V9.78842C9.99998 8.99189 10.6633 8.34614 11.4815 8.34614H15.6296Z"
            fill="currentColor"
        />
    </svg>
);

export default WalletIcon;
